import { action, observable } from 'mobx';
import { DefaultPageConfigurationType, DefaultPageType } from '../../../api/custom-pages.dao';


export type EntityProps = Exclude<DefaultPageConfigurationType, 'type' | 'enabled' | 'publicEnabled' | 'pageLinkEnabled'>;

const _props = Symbol('dto props');

export class DefaultPageEntity {
    public static create(props: DefaultPageConfigurationType): DefaultPageEntity {
        const { type, ...rest } = props;

        if (!type) throw new Error('Default Page Type is required');

        return new DefaultPageEntity(type, rest as EntityProps);
    }

    public toDTO(): DefaultPageConfigurationType {
        const dto = this.trimStringValues(this.getProps());

        dto.type = this.getType();
        dto.enabled = this.isEnabled();
        dto.publicEnabled = this.isPublicEnabled();
        dto.pageLinkEnabled = this.isPageLinkEnabled();

        return dto ;
    }

    public getType(): DefaultPageType {
        return this.type;
    }

    public canBeDisabled(): boolean {
        return this[_props].landingPage === false;
    }
    public isEnabled(): boolean {
        return this.enabled;
    }
    public isPublicEnabled(): boolean {
        return this.publicEnabled;
    }
    @action.bound
    public enable(): void {
        this.enabled = true;
    }
    @action.bound
    public disable(): void {
        if (this.canBeDisabled()) {
            this.enabled = false;
        }
    }

    @action.bound
    public publicEnable(): void {
        this.publicEnabled = true;
    }
    @action.bound
    public publicDisable(): void {
        this.publicEnabled = false;
    }

    public isPageLinkEnabled = (): boolean => {
        return this.pageLinkEnabled;
    };
    @action.bound
    public togglePageLinkEnabled(): void {
        this.pageLinkEnabled = !this.pageLinkEnabled;
    }

    public getProps(): EntityProps {
        return { ...this[_props] };
    }

    constructor(private readonly type: DefaultPageType, { enabled, publicEnabled, pageLinkEnabled, ...rest }: EntityProps) {
        this[_props] = rest;
        this.enabled = !!enabled;
        this.publicEnabled = !!publicEnabled;
        this.pageLinkEnabled = !!pageLinkEnabled;
    }

    private trimStringValues<T>(object: T): T {
        return Object.entries(object)
            .reduce((_object, [ key, value ]) => {
                _object[key] = typeof value === 'string' ? value.trim() : value;
                return _object;
            }, {} as T);
    }

    @observable
    private enabled: boolean;

    @observable
    private publicEnabled: boolean;

    @observable
    private pageLinkEnabled: boolean;
}

